<!-- Upgrade Trial Owner Modal-->
<div class="modal fade center-modal-specific" bsModal #subscriptionTrialEndedModal="bs-modal"
  [config]="{keyboard: false, backdrop: 'static'}" id="upgradetrial" tabindex="-1" [hidden]="isMobile">
  <div class="modal-dialog modal-dialog-centered trial-upgrade modal-dialog-scrollable">
    <div class="modal-content login-modal bg-popup box-shadow-popup border-all">
      <button *ngIf="isFromBanner" type="button" class="close" (click)="closeBeforeActions()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="pscrollbar-8 vh-100 ps">
        <perfect-scrollbar [config]="config">
          <div class="d-flex flex-column pb-4 pt-4 letter-space-0 bg-white pricing-container">
            <img *ngIf="isFromBanner" class="pricing-logo" alt="Trovve Logo Full Colored"
              src="https://cdn.trovve.com/trovve/Logo dark 150px.svg">
            <h2 class="pricing-title-v4 font-weight-800 tk-montserrat text-vf-dark" [ngClass]="{'pt-5': !isFromBanner}">
              {{ isFromBanner
              ? 'Superhuman productivity starts here.'
              : (permission.isGranted('Pages.Settings') ? 'Your free trial has ended' : 'Your trial has ended') }}</h2>
            <div class="text-vf-light tk-proxima-nova font-weight-normal" *ngIf="isFromBanner">
              Unlock limitless productivity with a Trovve subscription plan
            </div>
            <div class="text-vf-light tk-proxima-nova font-weight-normal"
              *ngIf="!isFromBanner && permission.isGranted('Pages.Settings')">
              To continue experiencing superhuman productivity with a Trovve subscription plan.
            </div>
            <div class="text-vf-light tk-proxima-nova font-weight-normal"
              *ngIf="!isFromBanner && !permission.isGranted('Pages.Settings')">
              Contact {{ appSession.tenant.ownerName }}, the account owner, or reach out to our sales team to upgrade
              to a paid subscription.
            </div>

            <div class="d-flex mx-2 pb-5 justify-content-center pricing-buttons flex-column"
              *ngIf="isFromBanner || permission.isGranted('Pages.Settings')">
              <table class="mb-2">
                <tbody>
                  <tr>
                    <td class="m-w-350"></td>
                    <td class="m-w-210"></td>
                    <td class="px-20 m-w-210">
                      <div class="ml-3 popular-plan">
                        <lucide-icon name="heart" [size]="13" [strokeWidth]="2" class="mr-1"></lucide-icon>
                        <span class="f-size-13">Popular</span>
                      </div>
                    </td>
                    <td class="m-w-210"></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td class="f-size-15 font-weight-semibold tk-montserrat m-w-210">
                      <span class="ml-3 text-none">STARTER</span>
                    </td>
                    <td class="f-size-15 font-weight-semibold tk-montserrat m-w-210">
                      <span class="ml-3 text-none">PROFESSIONAL</span>
                    </td>
                    <td class="f-size-15 font-weight-semibold tk-montserrat m-w-210">
                      <span class="ml-3 text-none">ENTERPRISE</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="pricing-table">
                <tbody>
                  <tr>
                    <td class="f-size-15 font-weight-semibold m-w-350">Number of users (min-max)</td>
                    <td>2-50</td>
                    <td class="f-size-15 font-weight-semibold text-vf-dark">2-50</td>
                    <td>50+</td>
                  </tr>
                  <tr>
                    <td class="f-size-15 font-weight-semibold m-w-350">Price per user</td>
                    <td class="f-size-15 font-weight-semibold">$19/month</td>
                    <td class="f-size-15 font-weight-semibold text-vf-dark">$190/year</td>
                    <td class="f-size-15 font-weight-semibold">Request quote</td>
                  </tr>
                  <tr>
                    <td class="f-size-15 font-weight-semibold m-w-350">Billing Cycle</td>
                    <td>Monthly</td>
                    <td class="f-size-15 font-weight-semibold text-vf-dark">Annually</td>
                    <td>Annually</td>
                  </tr>
                  <tr>
                    <td class="f-size-15 font-weight-semibold m-w-350">Amount billed each cycle</td>
                    <td>$19/user per month</td>
                    <td class="f-size-15 font-weight-semibold text-vf-dark">$190/user annually</td>
                    <td>Depends on quote</td>
                  </tr>
                  <tr>
                    <td class="f-size-15 font-weight-semibold m-w-350">Access to all app features </td>
                    <td><lucide-icon name="check" [size]="15" [strokeWidth]="2"></lucide-icon> </td>
                    <td><lucide-icon name="check" [size]="15" [strokeWidth]="2" class="text-vf-dark"></lucide-icon> </td>
                    <td><lucide-icon name="check" [size]="15" [strokeWidth]="2"></lucide-icon> </td>
                  </tr>
                  <tr>
                    <td class="f-size-15 font-weight-semibold m-w-350">AI Capabilities </td>
                    <td>Basic </td>
                    <td class="f-size-15 font-weight-semibold text-vf-dark">Advanced </td>
                    <td>Advanced </td>
                  </tr>
                  <tr>
                    <td class="f-size-15 font-weight-semibold m-w-350">Support options </td>
                    <td>Trovve only </td>
                    <td class="f-size-15 font-weight-semibold text-vf-dark">M365 + Trovve </td>
                    <td>M365 + Trovve </td>
                  </tr>
                  <tr>
                    <td class="f-size-15 font-weight-semibold">Custom Workflows </td>
                    <td>--</td>
                    <td class="f-size-15 font-weight-semibold text-vf-dark">2 custom workflows </td>
                    <td>10 custom workflows </td>
                  </tr>
                  <tr>
                    <td class="f-size-15 font-weight-semibold">Customer success manager </td>
                    <td>--</td>
                    <td>--</td>
                    <td><lucide-icon name="check" [size]="15" [strokeWidth]="2"></lucide-icon></td>
                  </tr>
                </tbody>
              </table>
              <table>
                <tbody>
                  <tr>
                    <td class="m-w-350"></td>
                    <td class="m-w-210">
                      <button (click)="showBillingDeatil('MONTHLY')" *ngIf="permission.isGranted('Pages.Settings')" [disabled]="isLoading"
                        class="btn bg-primary border-primary text-white hover-shadow rounded-pill ml-2 py-10 pr-3 pl-3 f-size-15">
                        Purchase starter<lucide-icon name="chevron-right" [size]="16" [strokeWidth]="2" class="ml-2"></lucide-icon>
                      </button>
                      <a href="https://calendly.com/trovve/trovve-enterprise-plan" target="_blank"
                        *ngIf="!isFromBanner && !permission.isGranted('Pages.Settings')"
                        class="btn bg-primary border-primary text-white hover-shadow rounded-pill ml-2 py-10 pr-3 pl-3 f-size-15">
                        Contact sales<lucide-icon name="chevron-right" [size]="16" [strokeWidth]="2" class="ml-2"></lucide-icon>
                      </a>
                    </td>
                    <td class="m-w-210">
                      <button (click)="showBillingDeatil('ANNUALLY')" [disabled]="isLoading"
                        *ngIf="permission.isGranted('Pages.Settings')"
                        class="btn bg-blue border-blue text-white hover-shadow rounded-pill ml-2 py-10 pr-3 pl-3 f-size-15">
                        Purchase pro<lucide-icon name="chevron-right" [size]="16" [strokeWidth]="2" class="ml-2"></lucide-icon>
                      </button>
                      <a href="https://calendly.com/trovve/trovve-enterprise-plan" target="_blank"
                        *ngIf="!isFromBanner && !permission.isGranted('Pages.Settings')"
                        class="btn bg-blue border-blue text-white hover-shadow rounded-pill ml-2 py-10 pr-3 pl-3 f-size-15">
                        Contact sales<lucide-icon name="chevron-right" [size]="16" [strokeWidth]="2" class="ml-2"></lucide-icon>
                      </a>
                    </td>
                    <td class="m-w-210">
                      <a href="https://calendly.com/trovve/trovve-enterprise-plan" target="_blank"
                        class="btn bg-primary border-primary text-white hover-shadow rounded-pill ml-2 py-10 pr-3 pl-3 f-size-15">
                        Contact sales<lucide-icon name="chevron-right" [size]="16" [strokeWidth]="2" class="ml-2"></lucide-icon>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <h2 class="pricing-title-v4 font-weight-800 tk-montserrat text-vf-dark f-size-35"
              *ngIf="isFromBanner || permission.isGranted('Pages.Settings')">Still deciding? <br> See
              what our customers have to say about Trovve.
            </h2>
            <div class="customer-testimonial"
              *ngIf="isFromBanner || permission.isGranted('Pages.Settings')">
              <div class="customer-testimonial-card">
                <div class="customer-testimonial-card-body">
                  <div class="customer-testimonial-card-body-text text-vf-light tk-proxima-nova font-weight-normal">Our
                    company was growing quickly and we really needed
                    to get our operations in order. That's when Trovve stepped in, With their help, we not only
                    streamlined our processes but also saw an impressive 50% growth after implementing their solutions.
                  </div>
                </div>
                <div class="customer-testimonial-card-header">
                  <img src="https://cdn.trovve.com/vfapp/images/user-image/Christine.png" alt="User Image"
                    class="customer-testimonial-card-header-img">
                  <div class="customer-testimonial-card-header-details">
                    <div class="customer-testimonial-card-header-details-name">Christine-Amelie Roberge</div>
                    <div class="customer-testimonial-card-header-details-position">Vice President/ Co-founder</div>
                    <div class="customer-testimonial-card-header-details-company">La2eClasse </div>
                  </div>
                </div>
              </div>
              <div class="customer-testimonial-card">
                <div class="customer-testimonial-card-body">
                  <div class="customer-testimonial-card-body-text text-vf-light tk-proxima-nova font-weight-normal">As
                    an accountant with a lot on my plate, I was
                    searching for an all-in-one system to manage my clients, tasks, and workflows, all while integrating
                    smoothly with my existing Microsoft 365 setup. Discovering Trovve was a game-changer, making
                    everything so much more manageable.</div>
                </div>
                <div class="customer-testimonial-card-header">
                  <img src="https://cdn.trovve.com/vfapp/images/user-image/Victor-2.png" alt="User Image"
                    class="customer-testimonial-card-header-img">
                  <div class="customer-testimonial-card-header-details">
                    <div class="customer-testimonial-card-header-details-name">Victor Aldin</div>
                    <div class="customer-testimonial-card-header-details-position">Founder</div>
                    <div class="customer-testimonial-card-header-details-company">Aldin & Associates Accounting</div>
                  </div>
                </div>
              </div>
              <div class="customer-testimonial-card">
                <div class="customer-testimonial-card-body">
                  <div class="customer-testimonial-card-body-text text-vf-light tk-proxima-nova font-weight-normal">
                    Trovve seamlessly transitioned us from remote servers
                    to a streamlined, cloud-based organization, simplifying our daily workflow and transforming the way
                    we handle our files, tasks and projects.</div>
                </div>
                <div class="customer-testimonial-card-header">
                  <img src="https://cdn.trovve.com/vfapp/images/user-image/Dai.png" alt="User Image"
                    class="customer-testimonial-card-header-img">
                  <div class="customer-testimonial-card-header-details">
                    <div class="customer-testimonial-card-header-details-name">Dai Matsurra</div>
                    <div class="customer-testimonial-card-header-details-position">Chief Admin Officer</div>
                    <div class="customer-testimonial-card-header-details-company">The Language Group</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </perfect-scrollbar>
      </div>
    </div>
  </div>
</div>
<div class="trovve-responsive" [hidden]="!isMobile">
  <div class="login-body">
    <div class="login-white-container">
      <div class="row align-items-center justify-content-center">
        <img src="https://cdn.trovve.com/trovve/login-left-logo.png" alt="Vineforce Main"
          class="login-main-image">
      </div>

      <div class="row my-20">
        <div class="col">
          <p class="f-size-20 tk-montserrat font-weight-bold text-center text-vf-dark login-title">Your free trial has
            ended</p>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col">
          <p class="f-size-14 font-weight-normal text-center text-vf-light login-title">Thank you for trying Trovve!
            Your trial has ended. <br>To upgrade, please log in from your desktop.</p>
        </div>
      </div>

      <div class="row align-items-center justify-content-center mt-0 f-size-16">
        <p class="text-center text-vf-dark f-size-16 font-weight-bold"><lucide-icon name="life-buoy" [size]="16" [strokeWidth]="2"></lucide-icon> Need help? <span
            class="font-weight-normal">Contact our</span><a href="https://forms.office.com/pages/responsepage.aspx?id=pgyIyWmlpkOJI1BwUax7G-aKh0QROtJBnWlce0FUzcFUMjVXTk1PWVZHMzBJSkhIN0taQVIwRFlaSi4u&origin=lprLink"
            class="font-weight-normal text-dark-purple font-weight-normal" target="_blank"> support team</a></p>
      </div>
    </div>
  </div>
</div>